import angular from 'angular';

import * as Invite from '../modules/catpainiq';

const DEFAULT_PAGE_SIZE = 10;
const MAX_PAGE_SIZE = 10000;
/**
 * @ngdoc function
 * @name myConsultApp.controller:catpainiqDashboardController
 * @description
 * # catpainiqDashboardController
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller('catpainiqDashboard', ($scope, $location, crumble, MediaService, utilities) => {
    if ($scope.isAdminUser || $scope.isSuperUser) {
      $location.path('/admin');
    }
    if (!$scope.isTiggerSubscribed && !$scope.isAdminUser) {
      $location.path('/find-a-pet');
    } else {
      $scope.crumble = crumble;
      crumble.update();
    }

    /*
     *  Scope Variables
     *
     */

    $scope.media = {
      success: {
        flagged: {},
        paginated: {},
        showFlagged: false,
      },
      failure: {
        flagged: {},
        paginated: {},
        showFlagged: false,
      },
    };

    $scope.tiggerOrganization = $scope.isAdminUser ? '' : $scope.currentOrganization.id;
    $scope.mediaCategories = '1';
    $scope.mediaTypes = '1,2,3';
    $scope.mediaSearch = null;
    $scope.showInstructions = true;
    $scope.showFailureVideos = true;

    $scope.inviteEmailSubject = Invite.generateInviteEmailSubject();
    $scope.inviteEmailBody = Invite.generateInviteEmailBody($scope.currentOrganization, false);
    $scope.encodedInviteEmailBody = encodeURIComponent($scope.inviteEmailBody);
    $scope.clientEmailCopied = false;

    /*
     *  Scope Methods
     *
     */

    $scope.getMediaToShow = (type) => {
      const mediaData = $scope.media[type];
      const showFlagged = $scope.media[type].showFlagged;

      if (!showFlagged) {
        return mediaData.paginated.files || [];
      }

      const { files, meta } = mediaData.flagged;

      if (!files || !meta) {
        return [];
      }

      const { current_page } = meta;

      const paginatedFiles = files.slice(
        (current_page - 1) * DEFAULT_PAGE_SIZE,
        current_page * DEFAULT_PAGE_SIZE,
      );

      return paginatedFiles;
    };

    $scope.getPaginatedMedia = (type) => {
      MediaService.getMedia(
        $scope.mediaSearch,
        undefined,
        type,
        $scope.mediaTypes,
        $scope.mediaCategories,
        $scope.tiggerOrganization,
      ).then((response) => {
        const mediaData = $scope.media[type];
        $scope.media[type] = {
          ...mediaData,
          paginated: {
            ...mediaData.paginated,
            files: response.files,
            meta: response.meta,
          },
        };
      });
    };

    $scope.getFlaggedMedia = (type) => {
      MediaService.getMedia(
        $scope.mediaSearch,
        undefined,
        type,
        $scope.mediaTypes,
        $scope.mediaCategories,
        $scope.tiggerOrganization,
        undefined,
        MAX_PAGE_SIZE,
      ).then((response) => {
        const files = response.files.filter(
          (file) => file.extra_data.flags && file.extra_data.flags.catpainiq_follow_up,
        );
        const mediaData = $scope.media[type];
        $scope.media[type] = {
          ...mediaData,
          flagged: {
            ...mediaData.flagged,
            files: files,
            meta: {
              ...response.meta,
              count: files.length,
            },
          },
        };
      });
    };

    $scope.getPaginatedMedia('success');
    $scope.getPaginatedMedia('failure');

    $scope.mediaFilterChange = (type) => {
      const newShowFlagged = !$scope.media[type].showFlagged;
      $scope.media[type].showFlagged = newShowFlagged;

      if (newShowFlagged) {
        $scope.getFlaggedMedia(type);
      } else {
        $scope.getPaginatedMedia(type);
      }
    };

    $scope.copyClientEmail = () => {
      $scope.clientEmailCopied = true;
      utilities.submitTelemetry({
        event: 'e_CopyClientEmail',
        eventAction: 'Copy Client Email',
        orgId: $scope.currentOrganization.id,
      });
    };

    $scope.goToMedia = (media, type) => {
      $location.path(`/media/edit/${media.id}`);
      $scope.setViewedDate(media, type);
    };

    $scope.catOwnerGuide = () => {
      utilities.submitTelemetry({
        event: 'e_CatOwnerGuide',
        eventAction: 'Cat Owner Guide',
        orgId: $scope.currentOrganization.id,
      });
    };

    $scope.inviteClient = () => {
      utilities.submitTelemetry({
        event: 'e_inviteClient',
        eventAction: 'Invite A Client',
        orgId: $scope.currentOrganization.id,
      });
    };

    $scope.showFAQs = () => {
      utilities.submitTelemetry({
        event: 'e_buttonClick',
        eventAction: 'FAQs',
        orgId: $scope.currentOrganization.id,
      });
    };

    $scope.showSettings = () => {
      utilities.submitTelemetry({
        event: 'e_buttonClick',
        eventAction: 'Settings',
        orgId: $scope.currentOrganization.id,
      });
    };

    $scope.showMedia = (processingStatus, oaResult) => {
      const oaStatus = oaResult > 0.7 ? 'positive' : 'negative';
      utilities.submitTelemetry({
        event: 'e_reviewMedia',
        eventAction: 'Dashboard',
        orgId: $scope.currentOrganization.id,
        processingStatus: processingStatus,
        oaStatus: oaStatus,
      });
    };

    $scope.toggleInstructions = () => {
      $scope.showInstructions = !$scope.showInstructions;
    };

    $scope.toggleFailureVideos = () => {
      $scope.showFailureVideos = !$scope.showFailureVideos;
    };

    /*
     *   Main
     */
    $scope.gotoPaginatedPage = (type, pageURL) => {
      MediaService.getMediaPage(pageURL).then((response) => {
        const mediaData = $scope.media[type];
        $scope.media[type] = {
          ...mediaData,
          paginated: {
            ...mediaData.paginated,
            files: response.files,
            meta: response.meta,
          },
        };
      });
    };

    $scope.goToSuccessPaginatedPage = (pageURL) => {
      $scope.gotoPaginatedPage('success', pageURL);
    };

    $scope.goToFailurePaginatedPage = (pageURL) => {
      $scope.gotoPaginatedPage('failure', pageURL);
    };

    $scope.gotoFlaggedPage = (type, page) => {
      const mediaData = $scope.media[type];
      $scope.media[type] = {
        ...mediaData,
        flagged: {
          ...mediaData.flagged,
          meta: {
            ...mediaData.flagged.meta,
            current_page: page,
          },
        },
      };
    };

    $scope.goToSuccessFlaggedPage = (page) => {
      $scope.gotoFlaggedPage('success', page);
    };

    $scope.goToFailureFlaggedPage = (page) => {
      $scope.gotoFlaggedPage('failure', page);
    };

    $scope.followUpMedia = (media, type) => {
      const flags = {
        catpainiq_follow_up: !media.extra_data.flags?.catpainiq_follow_up,
      };

      $scope.updateMedia(media, flags, type);
    };

    $scope.setViewedDate = (media, type) => {
      if (media.extra_data.flags?.catpainiq_viewed) {
        return;
      }

      const flags = {
        catpainiq_viewed: new Date(),
      };

      $scope.updateMedia(media, flags, type);
    };

    $scope.updateMedia = (media, flags, type) => {
      const settings = {
        files: {
          extra_data: {
            flags: {
              ...(media.extra_data.flags || {}),
              ...flags,
            },
          },
        },
      };

      MediaService.setMediaInfo(media.id, settings).then((response) => {
        const mediaData = $scope.media[type];
        const { showFlagged } = mediaData;
        const subType = showFlagged ? 'flagged' : 'paginated';

        $scope.media[type] = {
          ...mediaData,
          [subType]: {
            ...mediaData[subType],
            files: mediaData[subType].files.map((file) =>
              file.id === response.files.id ? response.files : file,
            ),
          },
        };
      });
    };
  });
